import { Action } from '@ngrx/store';

import { SelectNextByActionStep, StepNextType } from '../types';

// tslint:disable:unified-signatures
export class SelectNextByActionStepBuilder {
  // Don't want optional here, I want the coder to intentionally choose undefined when needed, and not implicitly.
  // tslint:disable-next-line:prefer-optional
  private actionsToDispatch: Action | Action[] | undefined = undefined;
  private readonly actionToNextStepMap: SelectNextByActionStep['next'] = [];

  public dispatch(
    value: Exclude<
      SelectNextByActionStepBuilder['actionsToDispatch'],
      undefined
    >,
  ): this {
    this.actionsToDispatch = value;
    return this;
  }

  public addActionToStep(
    matcher: (action: Action) => boolean,
    nextStep: StepNextType,
  ): this;
  public addActionToStep(action: Action, nextStep: StepNextType): this;
  public addActionToStep(
    actionOrMatcher: Action | ((action: Action) => boolean),
    nextStep: StepNextType,
  ): this;
  public addActionToStep(
    actionOrMatcher:
      | Action
      | (((action: Action) => boolean) & { type?: string }),
    nextStep: StepNextType,
  ): this {
    let matcher: (action: Action) => boolean;
    if (typeof actionOrMatcher === 'function') {
      if (actionOrMatcher.type === undefined) {
        matcher = actionOrMatcher;
      } else {
        matcher = (a: Action) => a.type === actionOrMatcher.type;
      }
    } else {
      matcher = (a: Action) =>
        JSON.stringify(a) === JSON.stringify(actionOrMatcher);
    }

    this.actionToNextStepMap.push({
      matcher,
      nextStep,
    });
    return this;
  }

  public addActionsToSteps(
    actionsToSteps: Parameters<
      SelectNextByActionStepBuilder['addActionToStep']
    >[],
  ): this {
    for (const actionToStep of actionsToSteps) {
      this.addActionToStep(...actionToStep);
    }
    return this;
  }

  public build(): SelectNextByActionStep {
    if (this.actionToNextStepMap.length === 0) {
      throw new Error(`No next steps have been defined for step`);
    }

    return {
      stepType: 'SelectNextByActionStep',
      dispatch: this.actionsToDispatch,
      next: this.actionToNextStepMap,
    };
  }
}
